import Days from './Days.vue';
import MajorMinorSubCode from './MajorMinorSubCode.vue';
import vSelect from 'vue-select'

const components = {
    Days,
    MajorMinorSubCode,
    vSelect
};
export default Vue => {
    Object.keys(components).map(val => {
        Vue.component(val, components[val]);
    })
};



// WEBPACK FOOTER //
// ./src/views/components/index.js